import React from 'react';
import { bool, func, object, string } from 'prop-types';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import MultiSensorSelect from './MultiSensorSelect';
import SensorTypeSelect from './SensorTypeSelect';

import defaultClasses from './ModifyRuleSensorModal.module.css';

const GeneralSourceFieldset = ({
    errors,
    hidden,
    onBlur,
    onChange,
    onPatch,
    ruleTarget,
    touched,
    values
}) => {
    if (hidden) {
        return null;
    }

    return (
        <FormControl
            aria-labelledby="general-sensor-label"
            className={defaultClasses.fieldset}
            role="group"
        >
            <FormLabel
                className={defaultClasses.legend}
                id="general-sensor-label"
                focused={false}
            >
                General Sensor Options
            </FormLabel>
            <SensorTypeSelect
                errors={errors}
                onBlur={onBlur}
                onPatch={onPatch}
                values={values}
                touched={touched}
            />
            <MultiSensorSelect
                errors={errors}
                onBlur={onBlur}
                onChange={onChange}
                values={values}
                ruleTarget={ruleTarget}
                touched={touched}
            />
        </FormControl>
    );
};

GeneralSourceFieldset.propTypes = {
    hidden:   false,
    onBlur:   () => {},
    onChange: () => {},
    onPatch:  () => {},
    sensor:   {},
    validity: {}
};

GeneralSourceFieldset.propTypes = {
    errors:     object,
    hidden:     bool,
    onBlur:     func,
    onChange:   func,
    onPatch:    func,
    ruleTarget: string,
    touched:    object,
    values:     object
};

export default GeneralSourceFieldset;
